import { useState } from "react";
import { motion } from "framer-motion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ShipmentDetails = ({ shipmentData, scannedPackages, drivers }) => {
  const { t } = useTranslation("carrier");
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => setShowDetails(!showDetails);

  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -5 }}
      className="border-b border-ui-border last:border-none transition shadow-elegant"
    >
      <>
        <div
          className={`p-2 flex justify-between items-center cursor-pointer rounded-md `}
          onClick={toggleDetails}
        >
          <span className="text-xs font-medium flex items-center">
            {t("dispatcher.shipmentDetails")}
          </span>
          <div className="flex items-center gap-1">
            {showDetails ? (
              <FaChevronUp size={10} />
            ) : (
              <FaChevronDown size={10} />
            )}
          </div>
        </div>

        <motion.div
          initial={false}
          animate={{
            maxHeight: showDetails ? 800 : 0,
            opacity: showDetails ? 1 : 0,
            padding: showDetails ? "8px" : "0px",
          }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className={`text-[10px] text-ui-text-muted rounded-md h-auto ${
            showDetails ? "" : "overflow-hidden"
          }`}
        >
          <div className="grid grid-cols-2 text-xs">
            <div className="my-[2px]">
              <strong>{t("dispatcher.pickupDriverLabel")}</strong>{" "}
              {
                drivers?.find(
                  (driver) => driver?.id === Number(shipmentData.pickup_driver)
                )?.name
              }
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.pickupAddressLabel")}</strong> {shipmentData.faddress}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.deliveryDriverLabel")}</strong>{" "}
              {
                drivers?.find(
                  (driver) =>
                    driver?.id === Number(shipmentData.delivery_driver)
                )?.name
              }
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.deliveryAddressLabel")}</strong> {shipmentData.taddress}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.pickupPhoneLabel")}</strong> {shipmentData.fphone}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.deliveryPhoneLabel")}</strong> {shipmentData.tphone}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.noOfPackagesLabel")}</strong>{" "}
              {shipmentData.shipment_details?.length ?? 0}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.scannedPackagesLabel")}</strong> {scannedPackages?.length}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.totalWeightLabel")}</strong> {shipmentData.total_weight}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.totalVolumeLabel")}</strong> {shipmentData.volume}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.pickupDateTimeLabel")}</strong> {shipmentData.PickupDate}
            </div>
            <div className="my-[2px]">
              <strong>{t("dispatcher.deliveryDateTimeLabel")}</strong> {shipmentData.deliverydate}
            </div>
          </div>
        </motion.div>
      </>
    </motion.div>
  );
};

export default ShipmentDetails;
